module.exports = __webpack_public_path__ + "img/banner_service.326edaec.png";